import {del, get, post, put} from "../util/http.service";

export const apiGetEvents = params => ({
  queryKey: ["events", {params}],
  queryFn: () => get("/api/events", params),
  placeholderData: (previousData) => previousData
});

export const apiCreateEvent = () => ({
  mutationFn: data => post("/api/events", data)
});

export const apiUpdateEvent = id => ({
  mutationFn: data => put("/api/events/" + id, data)
});

export const apiDeleteEvent = id => ({
  mutationFn: () => del("/api/events/" + id)
});
